import * as IsActive from '../../components/is_active'

export const FETCH_DOMAINS = 'FETCH_DOMAINS'
export const SERVER_RESOURCE = '/ippools'
export const ADD_DOMAIN = 'ADD_DOMAIN'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const EDIT_DOMAIN = 'EDIT_DOMAIN'
export const ON_EXIT = 'ON_EXIT'
export const SUBMIT_NEW_DOMAIN = 'SUBMIT_NEW_DOMAIN'
export const SUBMIT_DOMAIN_ERROR = 'There was an error submitting your domain. Please try again.'
export const VERIFY_DOMAIN = 'VERIFY_DOMAIN'
export const SUCCESSFUL_VERIFICATION = 'Your domain has been succesfully validated.'
export const FAILED_VERIFICATION = 'There has been an error validating your domain.'
export const COPY_TO_CLIPBOARD = 'COPY_TO_CLIPBOARD'
export const COPY_TO_CLIPBOARD_COMPLETE = 'COPY_TO_CLIPBOARD_COMPLETE'
export const CHANGE_VALIDATON_STATUS = 'CHANGE_VALIDATON_STATUS'
export const CHANGE_VALIDATON_STATUS_FILTER_STATUS = 'CHANGE_VALIDATON_STATUS_FILTER_STATUS'
export const DOMAIN_CREATED = 'DOMAIN_CREATED'
export const DOMAIN_NOT_CREATED = 'There was an error creating your domain.'

export const VERIFIED: IsActive.Filter = {
  description: 'Verified',
  key: 'mode',
  value: 'Verified',
}
export const FAILED: IsActive.Filter = {
  description: 'Failed',
  key: 'mode',
  value: 'Failed',
}
export const PENDING: IsActive.Filter = {
  description: 'Pending',
  key: 'mode',
  value: 'Pending',
}

export const DELETED: IsActive.Filter = {
  description: 'Deleted',
  key: 'mode',
  value: 'Deleted',
}

export const ALL: IsActive.Filter = {
  description: 'All',
  key: 'mode',
  value: 'All',
}

export const validationFilters = [PENDING, VERIFIED, FAILED, ALL]

export const SEARCH_INPUT = 'SEARCH_INPUT'

export const DELETE_DOMAIN = 'DELETE_DOMAIN'

export const SENDGRID_DELETE_ERROR = 'There was an error deleting your domain. Please try again'
export const SENDGRID_DELETE_SUCCESS = 'Domain succesfully deleted'



// WEBPACK FOOTER //
// ./src/pages/domain-authentication/constants.ts